<template>
  <div>
    <ed-email :intId="0" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdEmail from "@/components/configuracoes/importacao/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdEmail },
  mounted() {},
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>